const initialState = {
    formfilled: false,
  };
  
  const formfillReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FORM_FILLED":
        return {
          ...state,
          formfilled: action.payload, 
        };
      default:
        return state;
    }
  };
  
  export default formfillReducer;
  